import { IObject, IdefaultSearchParams } from "@/models/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { SERVER_API_URL } from "src/config/constants";

const INITIAL_STATE = {
  loading: false,
  errorMessage: null as unknown as string,
  fetchSuccess: false,
  fetchFailure: false,
  search: null as unknown as IObject[],
  count: null as unknown as number,
  refresh: 0,
};

export type ObcjectSearchState = Readonly<typeof INITIAL_STATE>;

export const getObjects = createAsyncThunk(
  "objects/search",
  async (params: IdefaultSearchParams, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<IObject[]> = await axios.post(
        `${SERVER_API_URL}/api/objects/search`,
        params
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const objectSearchSlice = createSlice({
  name: "post",
  initialState: INITIAL_STATE,
  reducers: {
    refreshObjectsSearch(state) {
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getObjects.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getObjects.fulfilled, (state, { payload }) => {
        return {
          ...state,
          loading: false,
          fetchSuccess: true,
          search: payload,
        };
      })
      .addCase(getObjects.rejected, (state) => {
        return {
          ...state,
          loading: false,
          fetchFailure: true,
        };
      });
  },
});

const { actions } = objectSearchSlice;
export const { refreshObjectsSearch } = actions;
export default objectSearchSlice.reducer;
